"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Text_1 = require("./Text");
var Skill_1 = require("./Skill");
var Markdown_1 = require("./Markdown");
function render(content, skillApi) {
    if (content.contentFormat === 'markdown') {
        return Markdown_1.renderMarkdown(content.text);
    }
    var path = Skill_1.detectSkill(content.text);
    if (path) {
        if (skillApi.isAvailableSkill(path)) {
            var id = path.replace(/^.*?form=([^&]+?)$/, '$1');
            // console.log('skill', id)
            return react_1.default.createElement(Skill_1.Skill, { src: "" + skillApi.baseUrl + path, id: id, token: skillApi.token });
        }
        return '';
    }
    var text = content.text && content.text.endsWith('\n') ? content.text : content.text ? content.text + "\n" : '';
    return Text_1.renderText(text);
}
function renderAnswer(content, skillApi) {
    var t = render(content, skillApi);
    if (content.image) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            t,
            !content.text ? null : react_1.default.createElement("br", null),
            react_1.default.createElement("a", { href: content.image, target: "_blank", rel: "noopener" },
                react_1.default.createElement("img", { src: content.image, style: { maxWidth: '100%' } }))));
    }
    return t;
}
exports.AnswerContent = function (_a) {
    var className = _a.className, contents = _a.contents, skillApi = _a.skillApi;
    return (react_1.default.createElement(core_1.Box, { width: "100%" }, contents.map(function (content, i) {
        return (react_1.default.createElement(core_1.Typography, { key: i + "--" + content.text, paragraph: true, component: "div", className: className }, renderAnswer(content, skillApi)));
    })));
};
//# sourceMappingURL=AnswerContent.js.map